import { useCallback, useLayoutEffect, useRef } from 'react';

/**
 * Keeps a scene's running Motion animations, so none outlives the scene:
 * `track(controls)` holds one until it finishes, and every one still running
 * is stopped when the scene unmounts (a looping vignette unmounts its scene
 * at the end of each cycle). Returns `track`.
 */
export default function useMotionControls() {
    const running = useRef(new Set());

    useLayoutEffect(() => {
        const controls = running.current;

        return () => {
            controls.forEach((control) => control.stop());
            controls.clear();
        };
    }, []);

    return useCallback((control) => {
        if (!control) return control;
        running.current.add(control);
        control.then(() => running.current.delete(control), () => {});

        return control;
    }, []);
}
